var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4788 48.9924C33.9926 48.5509 34.4822 48.4279 35.119 48.476L51.0392 49.6798C52.3128 49.7761 53.1958 50.8036 53.0995 52.0772C53.0032 53.3508 51.9757 54.2338 50.7021 54.1375L34.7819 52.9337C33.5083 52.8374 32.6254 51.8099 32.7217 50.5363C32.7698 49.8995 32.9651 49.4339 33.4788 48.9924Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6033 34.2749C51.1171 33.8334 51.6067 33.7103 52.2435 33.7585C53.5171 33.8548 54.4001 34.8822 54.3038 36.1558L53.1 52.076C53.0037 53.3496 51.9762 54.2326 50.7026 54.1363C49.429 54.04 48.546 53.0125 48.6423 51.7389L49.8462 35.8188C49.8943 35.1819 50.0896 34.7164 50.6033 34.2749Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8529 22.7979C26.8803 21.9149 28.1539 22.0112 29.0369 23.0386L52.5831 50.437C53.466 51.4645 53.3697 52.7381 52.3423 53.621C51.3149 54.504 50.0412 54.4077 49.1583 53.3803L25.6121 25.9819C24.7291 24.9545 24.8254 23.6809 25.8529 22.7979Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.20a75e498d289a97fada2a9d7b8da0cb.svg";
export { ForwardRef as ReactComponent };